<app-horizontal-wrapper
  [type]="type"
  [label]="label"
  [alignRight]="alignRight"
  [required]="formArray | isRequired"
  [col3]="col3"
  [marginBottom]="!inTable && marginBottom"
>
  <div>
    @if (isNew) {
      <div class="input-group">
        <ng-select
          [appendTo]="appendTo"
          [maxSelectedItems]="max"
          [closeOnSelect]="false"
          [clearSearchOnAdd]="true"
          [multiple]="true"
          [minTermLength]="3"
          [virtualScroll]="true"
          class="form-control"
          [class.in-table]="inTable"
          [class.text-sm]="inTable"
          [hideSelected]="hideSelected"
          [items]="options | async"
          [bindLabel]="labelProperty"
          [bindValue]="valueProperty"
          [dropdownPosition]="dropdownPosition"
          [formControl]="control"
          (remove)="onRemove($event)"
          (add)="onAdd($event)"
        >
        </ng-select>
        @if (modal) {
          <span class="input-group-text">
            <a (click)="open(content)">
              <i class="fa-solid fa-circle-info text-primary"></i>
            </a>
          </span>
        }
      </div>
    } @else {
      <div *ngIf="!modal">
        <div class="input-group">
          <ng-select
            [appendTo]="appendTo"
            (remove)="onRemove($event)"
            (add)="onAdd($event)"
            [maxSelectedItems]="max"
            [closeOnSelect]="false"
            [clearSearchOnAdd]="true"
            [multiple]="true"
            [minTermLength]="3"
            [virtualScroll]="true"
            class="form-control"
            [class.in-table]="inTable"
            [class.text-sm]="inTable"
            [hideSelected]="hideSelected"
            [items]="options | async"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="selectedIds"
            [dropdownPosition]="dropdownPosition"
            [disabled]="disabled"
          >
          </ng-select>
        </div>
      </div>
      <div *ngIf="modal" class="input-group">
        <ng-select
          [appendTo]="appendTo"
          (remove)="onRemove($event)"
          (add)="onAdd($event)"
          [maxSelectedItems]="max"
          [closeOnSelect]="false"
          [clearSearchOnAdd]="true"
          [multiple]="true"
          [minTermLength]="3"
          [virtualScroll]="true"
          class="form-control"
          [class.in-table]="inTable"
          [class.text-sm]="inTable"
          [hideSelected]="hideSelected"
          [items]="options | async"
          bindLabel="name"
          bindValue="id"
          [(ngModel)]="selectedIds"
          [dropdownPosition]="dropdownPosition"
          [disabled]="disabled"
        >
        </ng-select>
        <span class="input-group-text">
          <a (click)="open(content)">
            <i class="fa-solid fa-circle-info text-primary"></i>
          </a>
        </span>
      </div>
    }
    <app-validator [control]="formArray" [label]="label"></app-validator>
  </div>
</app-horizontal-wrapper>

<ng-template #content let-modal>
  <app-modal [activeModalInput]="modal">
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
  </app-modal>
</ng-template>
